module.exports = __webpack_public_path__ + "static/media/mrr_pamphlet015_0ct17.a4f45df5.jpg";